import { FC } from "react";

import { Stack } from "@mui/material";

import { IconWithBackground } from "../IconWithBackground/IconWithBackground";

import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";
import { IconElement } from "@/icons/types";

interface DeleteConfirmationsProps {
  icon?: IconElement;
  title: string;
  description?: string;
  cancel: {
    label: string;
    onClick: () => void;
  };
  confirm: {
    label: string;
    onClick: () => void;
  };
}

export const QuestionConfirmation: FC<DeleteConfirmationsProps> = ({ icon, title, description, cancel, confirm }) => {
  return (
    <Stack spacing={2}>
      <Stack alignItems="center" justifyContent="center">
        <IconWithBackground vibe="neutral" icon={icon} />
      </Stack>
      <Stack spacing={0.5}>
        <DashboardTypography
          variant="subtitle1"
          sx={{ marginLeft: (theme) => theme.spacing(0.25), textAlign: "center" }}
        >
          {title}
        </DashboardTypography>
        {description && (
          <DashboardTypography variant="body2" sx={{ marginLeft: (theme) => theme.spacing(0.25), textAlign: "center" }}>
            {description}
          </DashboardTypography>
        )}
      </Stack>
      <Stack direction="row" justifyContent="center" gap={1}>
        <DashboardButton variant="text" vibe="brand" onClick={cancel.onClick}>
          {cancel.label}
        </DashboardButton>
        <DashboardButton variant="tonal" vibe="brand" onClick={confirm.onClick} data-test="confirm-delete-button">
          {confirm.label}
        </DashboardButton>
      </Stack>
    </Stack>
  );
};
